export enum CommuteDirection {
  ARRIVAL = "arrival",
  DEPARTURE = "departure",
}
